import { IUser } from './user.interface';

export enum CourseStatus {
  Archived = -1,
  Inactive,
  Active,
}

export enum UserCourseStatus {
  Inactive,
  Active,
  AwaitingProfessorApproval,
  AwaitingStudentConfirmation,
}

export enum CoursePaidBy {
  Institute = 1,
  Player,
}

export interface ISimulator {
  id: number;
  name: string;
  status: number;
  locales: { name: string; code: string }[];
  prefix: string;
}

export interface ITextBook {
  id: string; // UUID from backend
  title: string;
  edition?: string;
  isbn?: string;
  publishedDate?: string;
  entryUrl: string; // URL to load in iframe
  simulations?: number[]; // Array of simulation IDs
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ISourceTemplate {
  id: number;
  name: string;
}

interface IStorage {
  id: number;
  engine: string;
  host: string;
  dbname: string;
  dbuser: string;
  dbpass: string;
  deployed: number;
  sqlVersion: number;
  created: string;
  modified: string;
  course: number;
}

export interface ICourseStorage {
  courseDB: IStorage;
  simulationDB: IStorage;
}

export interface ICourse {
  id: number;
  icon?: string;
  name: string;
  courseCode: string;
  description: string;
  userCount: number;
  instructors: IUser[];
  simulation: ISimulator;
  usercourse?: { status: UserCourseStatus; paid: boolean; logins: number };
  status: CourseStatus;
  paidBy: CoursePaidBy;
  price: number;
  bumpLeftLinkLevel: number;
  decisionLeftLinkLevel: number;
  parameterLeftLinkLevel: number;
  autoApproveUser: number;
  locale: string;
  simLogLevel: number;
  created: string;
  modified: string;
  endDate: string;
  includeTextbook: boolean;
  textbook: ITextBook;
  storage?: ICourseStorage;
  gameTemplate?: ISourceTemplate;
}

export interface ICourseLog {
  user: IUser;
  action: string;
  created: string;
  message: string;
}
